import { render, staticRenderFns } from "./FmlyLeter.vue?vue&type=template&id=ba8b8b0e&"
import script from "./FmlyLeter.vue?vue&type=script&lang=js&"
export * from "./FmlyLeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports